import React from "react";
import { Route, Switch } from "react-router-dom";
import "../../Styles/Admin/Admin.css";
import AdminDashBoard from "./AdminDashBoard";
import AdminNavBar from "./AdminNavBar";
import AdminAbout from "./AdminAbout";
import AdminProjects from "./AdminProjects";
import AdminSkills from "./AdminSkills";
import { app, database } from "../../Firebase/firebase";
import LogIn from "./LogIn";
function Admin() {
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [profile, setProfile] = React.useState({});
  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };
  React.useEffect(() => {
    let unsubscribe;
    if (isAdmin) {
      unsubscribe = database.collection("profile").onSnapshot((docs) => {
        setProfile({ id: docs.docs[0].id, ...docs.docs[0].data() });
      });
    }

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [isAdmin]);
  React.useEffect(() => {
    app.auth().onAuthStateChanged((user) => {
      if (user) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    });
  }, []);
  const login = (email, password) => {
    // app.auth().signInWithEmailAndPassword(email, password);
    console.log(email, password);
    app
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        setIsAdmin(true);
      })
      .catch((error) => {
        setIsError(error.message);
      });
  };
  return isAdmin ? (
    <div className="mainAdminContainer dark">
      <AdminNavBar />
      <Switch>
        <Route path="/admin/" exact>
          <AdminDashBoard {...profile} />
        </Route>
        <Route path="/admin/about">
          <AdminAbout handleChange={handleChange} profile={profile} />
        </Route>
        <Route path="/admin/projects">
          <AdminProjects />
        </Route>
        <Route path="/admin/skills">
          <AdminSkills />
        </Route>
      </Switch>
    </div>
  ) : (
    <LogIn login={login} isError={isError} />
  );
}

export default Admin;
